// /*eslint no-console: 0, new-cap: 0*/
// (function($){
//     // Match this with the breakpoint at which the screen transforms
//     // from smaller size to medium size
//     var $body = $('body');
//     var $nav = $('#navbar__dropdown');


//     //Append toggle-inner
//     function appendDropdownHelper() {
//         var $navbarList = $('.navbar__list');
//         var $menuDropdownHelper = $('<span class="toggle-inner"><span class="icon icon-chevron-down"></span></span>');

//         $('a', $navbarList).each(function () {
//             var $this = $(this);

//             // has sub
//             if ($this.next().is('div') || $this.next().is('ul')) {
//                 $this.after($menuDropdownHelper.clone());
//             }
//         });

//         // click toggle
//         $(document).on('click touchstart', '.navbar__list .toggle-inner', function (e) {
//             e.preventDefault();
//             $(this).toggleClass('active');
//             $(this).next('.sub-nav, .inner-sub-nav').slideToggle();
//         });

//         $('.navbar__item').each(function() {
//             if ($(this).has('div.sub-nav').length) { 
//                 $(this).addClass('navbar__item--haschildren');              
//             }
//         });

//     };

//     function openCurrentLevel() {

//         // add selected class to the link
//         var url = window.location.href;
//         var $selectedItem = $('a[href="' + url + '"]').parent('li');

//         if ($selectedItem.hasClass('navbar__item')) {
//             $selectedItem.addClass('current');
//         } else {
//             $selectedItem.addClass('selected');
//         }

//         var $selected = $('.navbar__list').find('.selected');
//         var $parents = $selected.parents();
//         var $children;

//         $parents.each(function() {
//             $children = $(this).children('.toggle-inner');
//             if ($children.length) {
//                 $children.addClass('active');
//                 $children.next('.sub-nav, .inner-sub-nav').show();
//             }
//         });

//     }


//     // Load the menu
//     function loadMenu() {
//         var isCurrent = $nav.find('.navbar__item--current .sub-nav').length !== 0;
//         $nav.NavBar({
//             onState: function($item, active) {
//                 if (isCurrent) {
//                     return;
//                 }
//                 if ($item.find('.sub-nav').length && active) {
//                     $body.addClass('is-nav-active');
//                 } else {
//                     $body.removeClass('is-nav-active');
//                 }
//             }
//         });

//         if (isCurrent) {
//             $body.addClass('is-nav-active');
//         }

//         appendDropdownHelper();
//         openCurrentLevel();

//     }


//     loadMenu();

//     // Mobile button toggler
//     $('.navbar').UberAccordion({
//         buttonClass: 'navbar__toggle'
//     });


//     $(window).on('resize', function() {
        
//         if ($('body').width()  >= 1024) {

//             if ($nav.css('display') === 'none') {
//                 $nav.show();  
//             }

//             $('.navbar__item').blur();
            
//         } else {


//             if ($nav.hasClass('uber-accordion__target-active')) {
//                 $nav.show();  
//             } else {
//                 $nav.hide();  
//             }

            
//             openCurrentLevel();
//         }

//     });

//     function hideMegaMenuLevels(displayed) {
//         var $megaInnerMenu = $('.inner-sub-nav');

//         $megaInnerMenu.each(function(i) {
//             var $this = $(this);
//             var $items = $this.children('li:gt('+displayed+')');

//             // Hide all items
//             $items.addClass('visuallyhidden');
//             $items.attr('aria-hidden', 'true');
//         });
//     }

//     //hideMegaMenuLevels(7);


// }(jQuery));

